import { makeStyles } from '@material-ui/core';
import { Grid, Hidden } from '@material-ui/core';
import { variables } from 'components/Theme';
import React, { useMemo } from 'react';
import useWidth from 'v2/hooks/useWidth';

const useStyles = makeStyles((theme) => ({
  td: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: 13,
    position: 'relative',
    lineHeight: 1.3,
    color: variables.palette.primary.light,
    background: theme.palette.grey[100],
    minHeight: theme.spacing(2) * 6,
    ['&.numeric' as any]: {
      textAlign: 'right',
    },
    ['&:first-child' as any]: {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      paddingLeft: theme.spacing(2),
      ['&.status ' as any]: {
        paddingLeft: 0,
        paddingRight: 16,
      },
    },
    ['&:last-child' as any]: {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      paddingRight: theme.spacing(2),
    },
  },
  tdCard: {
    fontSize: 13,
    position: 'relative',
    lineHeight: 1.3,
    padding: theme.spacing(2),
    color: variables.palette.primary.light,
    background: theme.palette.grey[100],

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
    },

    ['&.action' as any]: {
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
  },
}));

interface IProps {
  screenSizes?: any;
  colSpan?: any;
  numeric?: boolean;
  mobileOrder?: number;
  status?: any;
  classTd?: string;
  classTdCard?: string;
  action?: any;
  onClick?: any;
  children?: React.ReactNode;
}

const MyTableCol = ({ classTd = '', children, onClick, screenSizes, mobileOrder, numeric, status, action, colSpan }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});

  const hiddenField = useMemo(() => {
    let hiddens: any[] = [];
    for (let k in screenSizes) {
      if (screenSizes[k] === 0) {
        hiddens.push(k);
      }
    }
    return hiddens;
  }, [screenSizes]);

  if (width === 'md' || width === 'lg' || width === 'xl') {
    return (
      <td
        data-testid='mytablecol-td'
        colSpan={colSpan}
        className={`${classes.td} ${classTd} ${numeric ? 'numeric' : ''} ${status ? 'status' : ''}`}
        onClick={onClick}
      >
        {children}
      </td>
    );
  }

  return (
    <Hidden only={hiddenField}>
      <Grid
        data-testid='mytablecol-grid'
        item={true}
        style={{ order: mobileOrder ? mobileOrder : 'initial' }}
        className={classes.tdCard + (numeric ? ' numeric' : '') + (action ? ' action' : '') + (status ? ' status' : '')}
        xs={screenSizes['xs']}
        sm={screenSizes['sm']}
        md={screenSizes['md']}
        lg={screenSizes['lg']}
        onClick={onClick}
      >
        {children}
      </Grid>
    </Hidden>
  );
};

export default MyTableCol;
